// Client-safe MWRP configuration.
//
// (This used to be a multi-tenant map keyed by hostname. Valley was split out
// into its own separately-hosted project, so this is now a single MWRP config.)
// Anything that ships to the browser belongs here. Secrets (OAuth client
// secret, JWT secret, DB creds) stay on the API side — never in this file.

export const MWRP = {
  slug: 'mwrp',
  displayName: 'MWRP',

  discord: {
    clientId: '1506404224135856279',
    // OAuth callback path; the absolute URL is composed at runtime from
    // window.location.origin.
    callbackPath: '/auth/callback',
  },

  tebex: {
    storeUrl: 'https://mostwanted-rp.tebex.io',
    // Headless API webstore identifier ("public token"). Safe in the browser —
    // this is NOT the secret/Plugin API key.
    publicToken: 'tnre-21b37e2a43a677d041571aac79875249ecddaeb1',
    // Package IDs surfaced in the "Most Popular" row, in display order.
    featuredPackageIds: [],
  },

  inviteUrl: 'https://discord.gg/mwrp',

  branding: {
    brandName: 'MWRP',
    tagline: 'Most Wanted RP',
    themeClass: 'theme-mwrp',
    // Browser tab title + favicon, applied at runtime in main.jsx.
    tabTitle: 'MostWanted RP',
    favicon: '/mwrp-logo.png',
    // Header wordmark (replaces the text brand on the public site). Lives in /public.
    headerLogo: '/mostwanted_header.png',
    colors: {
      accent: '#3B82F6',
      accentHover: '#60A5FA',
      violet: '#8B5CF6',
      cyan: '#06B6D4',
    },
  },

  // Feature flags drive nav visibility and page availability.
  features: {
    awards: true,
    importsLog: true,
    radioLocks: true,
    gangManagementByRole: false,
    families: true,
    staffLoa: true,
    // One-off "keep or remove" resource vote. Hidden from the nav once voting
    // is done (the route still works for anyone with the link).
    resourceSwiper: false,
  },
}

// Single tenant — always MWRP. Kept for call sites that used the old resolver
// (main.jsx tab branding).
export function getCurrentTenant() {
  return MWRP
}
